<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1">
          <span slot="tab">
            <g-wiki keyValue="WIKI_CREDITOS"/>
            PRESTAMOS
          </span>
          <btn-generar-amortizacion @ismodalok="modalOk" :id_loans="id_loans" ref="amortizacionComponent"/>
          <g-master name="prestamos"
                    @params="paramsTable"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    :actions="master.actions"
                    @action="masterAction"
                    :beforeSend="master.beforeSend"
                    :useMultipart="true"
                    modalWidth="90%"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <span slot="estadoRenderer" slot-scope="{text}">
              <div v-if="text ==='CERRADO'">
                <a-tag color="red">{{text}}</a-tag>
              </div>
              <div v-if="text ==='ACTIVO'">
                <a-tag color="blue">{{text}}</a-tag>
              </div>
              <div v-if="text ==='INACTIVO'">
                <a-tag color="purple">{{text}}</a-tag>
              </div>
            </span>
            <template slot="expandedRowRender" slot-scope="{text}">
              <template v-for="ve in master.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </template>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Empleado')"
                            :formItemConfig="fiOptions"
                            endpoint="empleados_en_reqliquidacion"
                            ref="empleado"
                            :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Tipo amortizacion')"
                              :formItemConfig="fiOptions"
                              :decorator="['amortization_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="amortization_type_parm"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['status', { rules: [{ required: false, message: 'Valor requerido' }], initialValue: 'ACT' }]"
                              :params="estado"
                              :disabled="inactiveStatus"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Valor prestamo')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['ammount_loan', { rules: [{ required: true}] }]"
                                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Duración en cuotas')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['term_month', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha desembolso')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['loan_date',
                                   { rules: [{ required: true, message: 'Valor requerido' }] }]">
                    </a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Frecuencia Desc')"
                              :formItemConfig="fiOptions"
                              :decorator="['loan_period', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="periodos_liquidacion"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Concepto')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="loans_coc"
                              ref="concepto"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Moneda')"
                              :formItemConfig="fiOptions"
                              :decorator="['currency', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                              :params="code_currency">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Documento')">
                    <a-input
                      v-decorator="['document', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha primera cuota')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['date_event',
                                   { rules: [{ required: false, message: 'Valor requerido' }] }]">
                    </a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Saldo inicial')">
                    <a-input
                      v-decorator="['initial_balance', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Plazo en años')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['term_year', { rules: [{ required: false}] }]"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Tipo tasa')"
                              :formItemConfig="fiOptions"
                              :decorator="['rate_type', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="rate_type"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tasa')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['tasa', { rules: [{ required: false}] }]"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha terminación')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['end_date',
                                   { rules: [{ required: false, message: 'Valor requerido' }] }]">
                    </a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Tipo credito')">
                    <a-input
                      v-decorator="['loan_type', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Observaciones')">
                    <a-textarea autoSize
                                v-decorator="['observations', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                    </a-textarea>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Subir archivo')">
                    <a-upload
                      name="profile_file"
                      :before-upload="beforeUpload"
                      :fileList="master.uploads.profileFile"
                      :remove="() => { master.uploads.profileFile = [] }">
                      <a-button style="width: 100%">Seleccionar archivo</a-button>
                    </a-upload>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>

          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="PLAN DE AMORTIZACION DEL PRESTAMO" key="1">
              <creditos-amortizacion ref="amortizacion" v-if="id_loans" :id_loans="id_loans"></creditos-amortizacion>
              <span v-else>Seleccione un prestamo para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '../../../../../util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {

    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        inactiveStatus: false,
        loadingBtns: {},
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA_CER',
          use_code: true
        },
        loans_coc: {
          h_lookup_type: 'LOANS COC',
          use_code: true
        },
        pageTitle: 'Creditos',
        periodos_liquidacion: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        },
        rate_type: {
          h_lookup_type: 'RATE_TYPE',
          use_code: true
        },
        amortization_type_parm: {
          h_lookup_type: 'AMORTIZATION_TYPE',
          use_description: true
        },
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            return data
          },
          actions: [
            {
              name: 'generarAmortizacion',
              text: 'Generar Amortización',
              permisos: [],
              props: {icon: 'sketch', type: 'button'},
              fnVisible: (record) => {
                if (this.$userIsInrol('Query')) {
                  return false
                }
                return !JsUtils.isEmpty(this.id_loans)
              }
            },
            {
              name: 'reestructuracion',
              text: 'Reestructuración',
              permisos: [],
              props: {icon: 'branches', type: 'button'},
              fnVisible: (record) => {
                if (this.$userIsInrol('Query')) {
                  return false
                }
                return !JsUtils.isEmpty(this.id_loans)
              }
            },
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'}
            }
          ],
          valoresExpandidos: [
            {label: 'Moneda', column: 'currency'},
            {label: 'Fecha terminación', column: 'end_date_desc'},
            {label: 'Periodo', column: 'loan_period'},
            {label: 'Concepto', column: 'id_coc'},
            {label: 'Tipo credito', column: 'loan_type'},
            {label: 'Tipo tasa', column: 'rate_type'},
            {label: 'Tasa', column: 'tasa'},
            {label: 'Duracion en cuotas', column: 'term_month'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'loan',
          tableSetup: {
            customSlots: ['expandedRowRender', 'estadoRenderer'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Tipo de amortizacion', dataIndex: 'amortization_type', sorter: true},
              {title: 'Documento', dataIndex: 'document', sorter: true},
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre del empleado', dataIndex: 'nombre_empleado', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'F. primera cuota', dataIndex: 'date_event_desc', sorter: true},
              {title: 'F. desembolso', dataIndex: 'loan_date_desc', sorter: true},
              {title: 'Valor prestamo', dataIndex: 'ammount_loan', sorter: true, align: 'right'},
              {title: 'Saldo inicial', dataIndex: 'initial_balance', sorter: true, align: 'right'},
              {title: 'Saldo actual', dataIndex: 'saldo_actual', sorter: true, align: 'right'},
              {title: 'Plazo en años', dataIndex: 'term_year', sorter: true},
              {title: 'Observaciones', dataIndex: 'observations', sorter: true}
            ],
            allowSelect: true,
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    if (record.status === 'CER') {
                      return false
                    } else if (record.status === 'ACT') {
                      return true
                    }
                  }
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'ammount_loan'},
            {name: 'amortization_type'},
            {name: 'currency'},
            {name: 'date_event'},
            {name: 'document'},
            {name: 'end_date'},
            {name: 'id_coc'},
            {name: 'id_emp'},
            {name: 'initial_balance'},
            {name: 'loan_date'},
            {name: 'loan_period'},
            {name: 'loan_type'},
            {name: 'rate_type'},
            {name: 'tasa'},
            {name: 'term_month'},
            {name: 'term_year'},
            {name: 'status'},
            {name: 'observations'}
          ]
        },
        endpointExcel: 'loan_/downloadExcel',
        fileNameExcel: 'Prestamos',
        paramsT: {}
      }
    },
    props: ['prestamo_seleccionado'],
    methods: {
      modalOk () {
        this.$refs.amortizacion.loadData()
      },
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
        }
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record)
            break
          case 'generarAmortizacion':
            this.$refs.amortizacionComponent.showModal()
            break
          case 'reestructuracion':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea ejecutar la reestructuracion?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().post('loan/include_extra_fee', {
                    id_loans: this.id_loans
                  })
                    .then((response) => {
                      this.$refs.amortizacion.loadData()
                      Mensajes.success('Correcto', response.data.pvmessage)
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () {
              }
            })
            break

          case 'masterEdit':
            this.inactiveStatus = action.record.status === 'CER'
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
            })
            this.$refs.concepto && this.$refs.concepto.handleChange(action.record.id_coc)
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('loan/download', {
          id: record.id
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const array = ['application/pdf', 'image/jpeg', 'text/html', 'text/plain']
        const isJpgOrPng = file.type
        if (!array.includes(isJpgOrPng)) {
          this.$message.error('Solo se pemiten documentos pdf, jpeg o jpg, texto plano o html')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      id_loans () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      paramsExcel () {
        let columsDetail = this.master.valoresExpandidos.map(item => {
          item['title'] = item['label']
          item['dataIndex'] = item['column']
          return item
        })
        return {...this.paramsT, columns: this.master.tableSetup.columns.concat(columsDetail)}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/CreditosPrestamos.vue